export class Gym {
    public _id: string;
    public gymName: string;
    public ownedBy: string;
    public location: boolean;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/gym.ts